import { Logger } from 'beaver-logger';

let logger; // beaver logger instance

const getCurrentPathname = () => window?.location?.pathname || '';

// Reference: https://github.com/krakenjs/beaver-logger
// NOTE: exporting beaverLogger for unit tests
export const beaverLogger = () => {
  if (logger) {
    return logger;
  }
  // eslint-disable-next-line new-cap
  logger = Logger({
    url: '/ncp/api/log',
    prefix: '',
    flushInterval: 10 * 1000,
    logLevel: 'info'
  });

  logger.addMetaBuilder(function () {
    // add the current pathname to the meta so we can log it before all the other logs
    // and can tell where the user is
    return {
      currPathname: getCurrentPathname()
    };
  });

  return logger;
};

const getPayloadString = (payload: object | string | undefined): string => {
  if (!payload) {
    return '';
  }

  let payloadString = '';
  try {
    payloadString = typeof payload !== 'string' ? JSON.stringify(payload) : payload;
  } catch {
    console.error('getPayloadStringError Issue generating payload string');
  }

  return payloadString;
};

export const logInfoClient = (event: string, payload?: object | string): void => {
  beaverLogger().info(event, { payload: getPayloadString(payload) });
};

export const logErrorClient = (event: string, payload?: object | string): void => {
  beaverLogger().error(event, { payload: getPayloadString(payload) });
};

export const logWarnClient = (event: string, payload?: object | string): void => {
  beaverLogger().warn(event, { payload: getPayloadString(payload) });
};

export const logFptiClient = (payload?: object): void => {
  if (typeof payload !== 'object') {
    return;
  }
  beaverLogger().track(payload);
};
